// extracted by mini-css-extract-plugin
export default {"callLogBar":"index_callLogBar__ZdlIM"};